import { environment } from '@app/env';

export class AppSettings {
  public static pathToAssets = environment.languageAssetsPath;
}

export enum RouteName {
  segment = 'segment',
  simulator = 'simulator',
  quote = 'quote',
  smeQuote = 'sme-quote',
}

export const routeMap = [
  {
    name: RouteName.segment,
    basePath: {
      nl: environment.pathPrefixSegmentB2CNl,
      fr: environment.pathPrefixSegmentB2CFr,
    },
    regex: new RegExp(`^(${environment.pathPrefixSegmentB2CNl}|${environment.pathPrefixSegmentB2CFr})($|\/.*)`),
    f: () => import('./modules/evc-segment/evc-segment.module').then((m) => m.EvcSegmentModule),
  },
  {
    name: RouteName.simulator,
    basePath: {
      nl: environment.pathPrefixSimulatorB2CNl,
      fr: environment.pathPrefixSimulatorB2CFr,
    },
    regex: new RegExp(`^(${environment.pathPrefixSimulatorB2CNl}|${environment.pathPrefixSimulatorB2CFr})($|\/.*)`),
    f: () => import('./modules/ev-simulator/ev-simulator.module').then((m) => m.EvSimulatorModule),
  },
  {
    name: RouteName.quote,
    basePath: {
      nl: environment.pathPrefixQuoteB2CNl,
      fr: environment.pathPrefixQuoteB2CFr,
    },
    regex: new RegExp(`^(${environment.pathPrefixQuoteB2CNl}|${environment.pathPrefixQuoteB2CFr})($|\/.*)`),
    f: () => import('./modules/evc-quote/evc-quote.module').then((m) => m.EvcQuoteModule),
  },
  {
    name: RouteName.smeQuote,
    basePath: {
      nl: environment.pathPrefixQuoteSmeNl,
      fr: environment.pathPrefixQuoteSmeFr,
    },
    regex: new RegExp(`^(${environment.pathPrefixQuoteSmeNl}|${environment.pathPrefixQuoteSmeFr})($|\/.*)`),
    f: () => import('./modules/evc-small-biz/evc-small-biz.module').then((m) => m.EvcSmallBizModule),
  },
];
